import * as React from "react";

import $ from "jquery";

export interface IModalHtmlClassHack {
  modalIsOpen: boolean;
}

export const ModalHtmlClassHack = (props: IModalHtmlClassHack) => {

    // Have to add a class to the HTML tag while the react modal is open to prevent the body from scrolling.

    if (props.modalIsOpen) {
        $("html").addClass("CMS_PF_dialog_open");
    } else {
        $("html").removeClass("CMS_PF_dialog_open");
    }

    return null;
};
